<template>
    <div class="container">
        <div class="searchBox">
          <el-form :inline="true" :model="formData">
              <el-row >
                <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="通知标题">
                    <el-input v-model="formData.title" placeholder="请输入通知标题 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="通知内容">
                    <el-input v-model="formData.content" placeholder="请输入通知内容 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12" class="leftAlignTtem">
                  <el-form-item label="发布时间">

                      <el-date-picker type="date" placeholder="开始时间" v-model="formData.start" ></el-date-picker>
                      <span>-</span>
                      <el-date-picker type="date" placeholder="结束时间" v-model="formData.end" ></el-date-picker>

                  </el-form-item>
              </el-col>
            </el-row>
            <el-row class="gapRow">
              <el-col :span="24" class="">
                <el-form-item>
                  <el-button type="primary" @click="query" icon="el-icon-search"  round >查询</el-button>
                  <el-button type="danger" @click="addClick" icon="el-icon-edit" round>发布新消息</el-button>
                  <el-button round @click="reset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="contentBox" >
          <el-table stribe :data="tableData"  fit>
            <el-table-column label="通知标题" fixed prop="noticeTitle" width="240"></el-table-column>
            <el-table-column label="发布日期" prop="publishTime" width="180" ></el-table-column>
            <el-table-column  label="通知内容"  prop="noticeContent" ></el-table-column>
            <el-table-column  label="通知附件" >
              <template slot-scope="scope">
                <el-link v-for="item in scope.row.noticeAttachments" :key="item.attachmentId" :href="item.attachmentUrl" target="_blank"  style="margin-right: 20px;">{{item.attachmentName}}</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10,20,30,40,50]"
      :page-size="pageSize"
       layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
      <el-drawer
          title="新增消息通知"
          :before-close="handleClose"
          :visible.sync="dialog"
          direction="ltr"
          custom-class="demo-drawer"
          ref="drawer"
          >
          <div class="demo-drawer__content">
            <el-form :model="editForm">
              <el-form-item label="通知标题" :label-width="formLabelWidth" >
                <el-input v-model="editForm.title" class="modelInput"></el-input>
              </el-form-item>
              <el-form-item label="通知内容" :label-width="formLabelWidth">
                 <el-input type="textarea" v-model="editForm.content" :autosize="{ minRows: 2, maxRows: 6}" class="modelInput"></el-input>
              </el-form-item>
              <el-form-item label="上传附件" :label-width="formLabelWidth">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  :action="uploadUrl"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  multiple
                  :limit="3"
                  :file-list="attachmentList"
                  :headers="headerObj"
                  ::auto-upload="false">
                  <el-button  type="success" round size="small">点击上传</el-button>
                  </el-upload>
              </el-form-item>
            </el-form>
            <div class="demo-drawer__footer">
              <el-button @click="cancelForm" round size="small">取 消</el-button>
              <el-button type="primary" @click="submitEdit" :loading="loading" icon="el-icon-edit" round size="small">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
            </div>
          </div>
      </el-drawer>
      </div>
    </div>
</template>

<script>
import request from '@/lib/utils'
import router from '../../router'

export default {
  name: 'notice',
  data () {
    return {
      formData: {
        title: '',
        content: '',
        start: '',
        end: ''
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      editForm: {
        title: '',
        content: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      loading: false,
      dialog: false,
      timer: null,
      formLabelWidth: '80px',
      uploadUrl: process.env.API_URL + 'notice/uploadAttachments',
      attachmentList: [],
      headerObj: {
        'auth-token': ''
      }
    }
  },
  methods: {
    query () {
      const that = this
      let formData = {
        noticeTitle: this.formData.title,
        noticeContent: this.formData.content,
        publishTimeStart: this.formData.start,
        publishTimeEnd: this.formData.end,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      let requestData = {
        formClass: 'NoticeQuery',
        formData: JSON.stringify(formData)

      }
      request.post('/notice/queryPageForm', requestData).then(res => {
        that.tableData = res.obj.list
        that.total = res.obj.total
      })
    },
    addClick () {
      this.dialog = true
    },
    reset () {
      this.formData = {
        title: '',
        content: '',
        start: '',
        end: ''
      }
    },
    handleSizeChange (cureentSize) {
      this.pageSize = cureentSize
      this.query()
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.query()
    },
    cancelForm () {
      this.loading = false
      this.dialog = false
      clearTimeout(this.timer)
    },
    handleClose () {
      const that = this
      if (that.loading) {
        return
      }
      that.$confirm('不提交 直接退出吗?')
        .then(_ => {
          that.cancelForm()
        })
        .catch(_ => {})
    },
    submitEdit () {
      const that = this
      let formData = {
        noticeTitle: this.editForm.title,
        noticeContent: this.editForm.content
      }
      let attachmentArray = []
      for (let attchment of that.attachmentList) {
        let file = {}
        file.attachmentName = attchment.response.obj.fileList[0].fileName
        file.attachmentUrl = attchment.response.obj.fileList[0].fileUrl
        attachmentArray.push(file)
      }
      formData.noticeItemList = attachmentArray
      let requestData = {
        formClass: 'NoticeAdd',
        formData: JSON.stringify(formData)

      }
      request.post('/notice/addNotice', requestData).then(res => {
        that.$message({
          message: '新增消息成功',
          type: 'success'
        })
        that.cancelForm()
        that.query()
      })
    },
    handlePreview (file) {
      console.log(file)
    },
    handleChange (_file, fileList) {
      this.attachmentList = fileList
    },
    handleRemove (_file, fileList) {
      this.handleChange(_file, fileList)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    }

  },
  mounted () {
    this.headerObj['auth-token'] = localStorage.getItem('auth-token')
    this.query()
    let activeIndex = sessionStorage.getItem('activeIndex')
    console.log('activeIndex:' + activeIndex)
    if (activeIndex === '2') {
      router.push({ path: '/parts' })
    }
    if (activeIndex === '3') {
      router.push({ path: '/contracts' })
    }
    if (activeIndex === '4') {
      router.push({ path: '/issues' })
    }
    if (activeIndex === '5') {
      router.push({ path: '/signRecord' })
    }
    if (activeIndex === '6') {
      router.push({ path: '/loginRecord' })
    }
    if (activeIndex === '7') {
      router.push({ path: '/mfgManager' })
    }
    if (activeIndex === '8') {
      router.push({ path: '/invoiceUpload' })
    }
    if (activeIndex === '9') {
      router.push({ path: '/signPlan' })
    }
  }
}

</script>

<style scoped>

  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:70% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 70%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

</style>



// WEBPACK FOOTER //
// src/page/subPage/Notice.vue